import { InventoryCheckEventType } from '@boma/supplier-portal/shared/entities';
const eventTypesMap = {
  [InventoryCheckEventType.Scheduled]: 'scheduled',
  [InventoryCheckEventType.InProgress]: 'inProgress',
  [InventoryCheckEventType.AwaitingAuthorisation]: 'awaitingConfirmation',
  [InventoryCheckEventType.Authorised]: 'awaitingAuthorization',
  [InventoryCheckEventType.Completed]: 'completed',
  [InventoryCheckEventType.Cancelled]: 'cancelled',
  [InventoryCheckEventType.Rejected]: 'declined',
};
export class StatusSummary {
  public scheduled: number;
  public inProgress: number;
  public awaitingConfirmation: number;
  public awaitingAuthorization: number;
  public completed: number;
  public cancelled: number;
  public declined: number;

  constructor(partial: Partial<StatusSummary>) {
    Object.assign(this, partial);
  }
}

export class InventoryCheckDailySummaryResponse extends StatusSummary {
  public totalLocations: number;
  public locationSummaries: LocationInventoryCheckSummary[];

  constructor(partial: Partial<InventoryCheckDailySummaryResponse>) {
    super(partial);
    Object.assign(this, partial);
  }

  updateQuantities(
    locationId: string,
    nextEvent: InventoryCheckEventType,
    previousEvent: InventoryCheckEventType | null
  ): InventoryCheckDailySummaryResponse {
    const next = new InventoryCheckDailySummaryResponse(this);
    next.locationSummaries = next.locationSummaries.map((ls) => {
      if (ls.id === locationId) return ls;
      ls = this.subtractFromTotal(previousEvent, ls);
      ls = this.addToTotal(nextEvent, ls);
      return ls;
    });
    const propertyToAdd = eventTypesMap[nextEvent];
    const propertyToSubtract = eventTypesMap[previousEvent];

    if (propertyToAdd !== undefined) {
      next[propertyToAdd] += 1;
    }
    if (propertyToSubtract !== undefined) {
      next[propertyToSubtract] -= 1;
    }

    return next;
  }

  private subtractFromTotal(
    type: InventoryCheckEventType,
    locationSummary: LocationInventoryCheckSummary
  ) {
    const propertyToUpdate = eventTypesMap[type];
    if (propertyToUpdate !== undefined) {
      locationSummary[propertyToUpdate] -= 1;
    }
    return locationSummary;
  }

  private addToTotal(
    type: InventoryCheckEventType,
    locationSummary: LocationInventoryCheckSummary
  ) {
    const propertyToUpdate = eventTypesMap[type];
    if (propertyToUpdate !== undefined) {
      locationSummary[propertyToUpdate] += 1;
    }
    return locationSummary;
  }
}

export class LocationInventoryCheckSummary extends StatusSummary {
  public id: string;

  constructor(partial: Partial<LocationInventoryCheckSummary>) {
    super(partial);
    Object.assign(this, partial);
  }
}
